'use strict';
require('./SearchPortalDirective.js');

function EmailToObjectEditCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  priorities,
  categories,
  flowVerifies,
  growl,
  recv
  ) {
  $scope.recv = recv;
  $scope.priorities = priorities;
  $scope.categories = categories;
  $scope.flowVerifies = flowVerifies;
  $scope.$parent.nonWatchers = [];
  $scope.save = function() {
    $scope.recv.$update({
      companyId: $stateParams.companyId,
      emailId: $scope.recv.id
    }, function(){
      growl.addSuccessMessage($translate.instant('email-to-object.save-success'));
      $state.go('root.company.account.email.list');
    }, function(){
      growl.addErrorMessage($translate.instant('email-to-object.save-failure'));
    });
  };
}

EmailToObjectEditCtrl.resolve = {
  recv: ['EmailToObjectService', '$stateParams', function(EmailToObjectService, $stateParams){
    return EmailToObjectService.get({
      companyId: $stateParams.companyId,
      emailId: $stateParams.emailId
    }).$promise;
  }],
  categories: ['$stateParams', 'CompanyCategoryService', function ($stateParams, CompanyCategoryService) {
    return CompanyCategoryService.query({
      companyId: $stateParams.companyId,
      limit: 100
    }).$promise;
  }],
  flowVerifies: ['$stateParams', 'CompanyFlowVerifiesService', function ($stateParams, CompanyFlowVerifiesService) {
    return CompanyFlowVerifiesService.query({
      companyId: $stateParams.companyId,
      limit: 100
    }).$promise;
  }]
};

module.exports = EmailToObjectEditCtrl;

angular.module('dokiv')
  .controller('EmailToObjectEditCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$translate',
    'priorities',
    'categories',
    'flowVerifies',
    'growl',
    'recv',
    EmailToObjectEditCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/EmailToObjectEditCtrl.js
// module id = 342
// module chunks = 0